/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */

// 人力资源
import RoleIndex from './role/Index';

import UserIndex from './user/Index';

import SerialNumberIndex from './serialNumber/Index';
import SerialNumberAdd from './serialNumber/PageAdd';
import SerialNumberEdit from './serialNumber/PageEdit';

import DictIndex from './dict/Index';

import GlobalConfigIndex from './config/Index';

import FunctionIndex from './function/Index';

const router = {
  path: 'boss',
  breadcrumbName: '开发者中心',
  childRoutes: [
    {
      path: `serialNumber`,
      breadcrumbName: '角色管理',
      indexRoute: { component: SerialNumberIndex },
      childRoutes: [
        {
          path: 'add',
          breadcrumbName: '新增流水号',
          component: SerialNumberAdd,
        },
        {
          path: 'edit/:uuid',
          breadcrumbName: '编辑流水号',
          component: SerialNumberEdit,
        },
      ],
    },

    {
      path: 'dict',
      breadcrumbName: '字典设置',
      indexRoute: { component: DictIndex },
      childRoutes: [],
    },
    {
      path: 'global/config',
      breadcrumbName: '系统配置项设置',
      indexRoute: { component: GlobalConfigIndex },
      childRoutes: [],
    },
    {
      path: 'function',
      breadcrumbName: '系统菜单栏设置',
      indexRoute: { component: FunctionIndex },
      childRoutes: [],
    },

    {
      path: 'role',
      breadcrumbName: '角色管理',
      indexRoute: { component: RoleIndex },
      childRoutes: [],
    },
    {
      path: 'user',
      breadcrumbName: '用户管理',
      indexRoute: { component: UserIndex },
      childRoutes: [],
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/boss/router.js